import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { Store as StoreIcon } from '@mui/icons-material';

interface StoreAvatarProps extends AvatarProps {
  storeAvatar?: string;
  storeName?: string;
}

const StoreAvatar: React.FC<StoreAvatarProps> = ({ 
  storeAvatar, 
  storeName, 
  ...avatarProps 
}) => {
  // Handle potential URL issues
  const avatarSrc = storeAvatar ? (
    storeAvatar.startsWith('http') ? storeAvatar : `${window.location.origin}${storeAvatar}`
  ) : undefined;
  
  return (
    <Avatar
      src={avatarSrc}
      alt={storeName ? `${storeName} avatar` : 'Store avatar'}
      {...avatarProps}
    >
      {!storeAvatar && <StoreIcon sx={{ fontSize: 'inherit' }} />}
    </Avatar>
  );
};

export default StoreAvatar;
